// Global commands (exported form index) are places here
// Many of these commands are used from both Master and Workers, so the source of them is here.
// Worker commands (WORKER_COMMAND_nnn) are exposed from the implementation that supports it.
// Worker commands are exposed only from the place that implements them.
// This is done also to avoid circular references (webpack values them as undefined and it doesn't throw an error),
// or complex structures to avoid the circular references.
// Currency services
export var COMMAND_GetCurrencyRates = "COMMAND_GetCurrencyRates";
// Search airport
export var COMMAND_searchAirport = "COMMAND_searchAirport";
export var COMMAND_searchAirportResults = "COMMAND_searchAirportResults";
// Search flight
export var COMMAND_searchFlights = "COMMAND_searchFlights";
export var COMMAND_searchFlightsUpdateOperationId = "COMMAND_searchFlightsUpdateOperationId";
export var COMMAND_searchFlightsRequestAgentLink = "COMMAND_searchFlightsRequestAgentLink";
export var COMMAND_searchFlightsResponseAgentLink = "COMMAND_searchFlightsResponseAgentLink";
export var COMMAND_TPFetchSearchIdAndCurrencies_response = "COMMAND_TPFetchSearchIdAndCurrencies_response";
export var COMMAND_updateCurrencies = "COMMAND_updateCurrencies";
export var COMMAND_searchFlightsUpdateTrips = "COMMAND_searchFlightsUpdateTrips";
export var COMMAND_searchFlightsUpdateProgress = "COMMAND_searchFlightsUpdateProgress";
export var COMMAND_searchFlightsCompleted = "COMMAND_searchFlightsCompleted";
export var COMMAND_userCancelFlightSearchByOperationId = "COMMAND_userCancelFlightSearchByOperationId";
//# sourceMappingURL=interfaces.js.map